import { validationRules, createValidator } from "../../utils/validation";

export const transactionSchema = {
    transactionType: [
        validationRules.required("Transaction Type is required"),
    ],
}

export const saleTrasactionTypeSchema = {
    salePrice: [
        validationRules.required("Sale Price is required"),
    ],
}
export const PurchaseTrasactionTypeSchema = {
    purchasePrice: [
        validationRules.required("Purchase Price is required"),
    ],
}

export const LettingTrasactionTypeSchema = {
    term: [
        validationRules.required("Term is required"),
    ],
    ratePerAnnum: [
        validationRules.required("Highest Ascertainable Rent Per Annum is required"),
    ],
}

export const validateTrasactionForm = (type) => {
    switch (type) {
        case "Sale":
            return createValidator(saleTrasactionTypeSchema);
        case "Purchase":
            return createValidator(PurchaseTrasactionTypeSchema);
        case "Letting":
            return createValidator(LettingTrasactionTypeSchema);
        default:
            return createValidator(transactionSchema);
    }
}